export function buildManageCostsPageQueryV1(workspaceId: number, strategyId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Costs.Queries.ManageCostsPageQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
    }
}

export function buildExpenseAccountsByStrategyIdQueryV1(workspaceId: number, strategyId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Costs.Queries.ExpenseAccountsByStrategyIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
    }
}

export function buildExpenseAccountByIdQueryV1(workspaceId: number, strategyId: string, expenseId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Costs.Queries.ExpenseAccountByIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
        'ExpenseId': expenseId,
    }
}
